import { create } from "zustand";

const useUserStore = create((set, get) => ({
  balanceDC: 0,
  setBalanceDC: (value) =>
    set((state) => ({
      balanceDC: value,
    })),

  balanceUSDT: 0,
  setBalanceUSDT: (value) =>
    set((state) => ({
      balanceUSDT: value,
    })),

  balance: 0,
  setBalance: (value) =>
    set((state) => ({
      balance: value,
    })),

  tickets: 0,
  setTickets: (value) =>
    set((state) => ({
      tickets: value,
    })),

  // Mining Percent
  percent: 0,
  setPercent: (value) =>
    set((state) => ({
      percent: value,
    })),

  dateStart: 0,
  setDateStart: (value) => {
    const timestamp =
      typeof value === "string"
        ? new Date(value + "Z").getTime() // Добавляем 'Z' для UTC
        : Number(value);

    if (isNaN(timestamp) || timestamp <= 0) {
      // console.error('Invalid dateStart value:', value)
      return;
    }

    set({ dateStart: timestamp });
  },

  dateEnd: 0,
  setDateEnd: (value) => {
    const timestamp =
      typeof value === "string"
        ? new Date(value + "Z").getTime() // Добавляем 'Z' для UTC
        : Number(value);

    if (isNaN(timestamp) || timestamp <= 0) {
      // console.error('Invalid dateEnd value:', value)
      return;
    }

    set({ dateEnd: timestamp });
  },

  // serverTime: 0,
  // setServerTime: (value)=>set((state)=>({
  //     serverTime: value
  // })),

  miningReward: 0,
  setMiningReward: (value) =>
    set((state) => ({
      miningReward: value, //todo УДАЛИТЬ ПОСЛЕ ТЕСТОВ
    })),

  miningRewardDC: 0,
  miningRewardUSDT: 0,
  setMiningRewardDC: (value) => set({ miningRewardDC: value }),
  setMiningRewardUSDT: (value) => set({ miningRewardUSDT: value }),

  miningTime: 0,
  setMiningTime: (value) =>
    set((state) => {
      // Если время больше 1, блокируем кнопку
      const shouldBlock = value >= 1;
      return {
        miningTime: value,
        isMiningButtonBlocked: shouldBlock,
      };
    }),

  isAllTasksComplete: true,
  setIsAllTasksComplete: (value) =>
    set((state) => ({
      isAllTasksComplete: value,
    })),

  // Добавляем miningStatus
  miningStatus: "start",
  setMiningStatus: (status) => {
    set({ miningStatus: status });
  },

  miningId: 0,
  setMiningId: (value) =>
    set((state) => ({
      miningId: value,
    })),

  adsgram_ads_allowed: true,
  setAdsgramAdsAllowed: (value) =>
    set((state) => ({
      adsgram_ads_allowed: value,
    })),

  questEndDate: Date.now(),
  setQuestEndDate: (value) => {
    set({ questEndDate: value });
  },

  serverTime: Date.now(),
  setServerTime: (value) => {
    set({ serverTime: value });
  },

  isQuestDataLoaded: false,
  setQuestDataLoaded: (value) =>
    set((state) => ({
      isQuestDataLoaded: value,
    })),

  // Добавляем состояние для блокировки кнопки
  isMiningButtonBlocked: false,
  setMiningButtonBlocked: (value) => set({ isMiningButtonBlocked: value }),

  // Добавляем состояние для last_boost_time
  lastBoostTime: null,
  setLastBoostTime: (value) => {
    if (!value) {
      set({ lastBoostTime: null });
      return;
    }
    // Убедимся, что значение в правильном формате
    const timestamp = new Date(value + "Z").getTime();
    if (isNaN(timestamp)) {
      // console.error('Invalid lastBoostTime value:', value);
      return;
    }
    set({ lastBoostTime: value });
  },
  originalDateEnd: 0,
  setOriginalDateEnd: (value) => {
    const timestamp =
      typeof value === "string"
        ? new Date(value + "Z").getTime()
        : Number(value);

    if (isNaN(timestamp) || timestamp <= 0) {
      return;
    }

    set({ originalDateEnd: timestamp });
  },
}));

export default useUserStore;
